import { MethodDescription } from '../method-description';

export const DashboardBannersDescription = new MethodDescription();

DashboardBannersDescription.name = 'dashboardBanners';
DashboardBannersDescription.fields = [
	'language'
];
DashboardBannersDescription.usesToken = true;
